import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar, Mousewheel } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);

export default class PdpMediaGallery {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * product carousel element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.sliderElementIsDesktop = false;
        this.navigationPrev = this.sliderElement.querySelector('.js-pdp-media-gallery-desktop-navigation-prev');
        this.navigationNext = this.sliderElement.querySelector('.js-pdp-media-gallery-desktop-navigation-next');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');

        if (this.sliderElement.classList.contains('js-pdp-media-gallery-desktop')) {
            this.sliderThumbnailsElement = this.sliderElement.closest('.js-pdp-media-gallery-context').querySelector('.js-pdp-media-gallery-thumbnails');
            this.sliderElementIsDesktop = true;
        }

        this.init()
    }

    init() {
        const breakpoint = ! this.sliderElement.classList.contains('js-pdp-media-gallery-desktop') ? window.matchMedia('(min-width: 767px)') : null;
        let carousel;
        let carouselThumbnails;
        let self = this;

        const breakpointChecker = function() {
            if (breakpoint.matches === true) {
                if (carousel !== undefined) {
                    carousel.destroy(true, true);
                    window.pdpCarousel = null;
                    window.pdpCarouselThumbnails = null;
                }

                /**
                 * Removes `swiper` classes.
                 */
                self.sliderElement.classList.remove('swiper');
                self.sliderElement.querySelector('.js-swiper-wrapper').classList.remove('swiper-wrapper');
                self.sliderElement.querySelectorAll('.js-swiper-slide').forEach(slide => slide.classList.remove('swiper-slide'));

                if (self.sliderElementIsDesktop) {
                    self.sliderThumbnailsElement.classList.remove('swiper');
                    self.sliderThumbnailsElement.querySelector('.js-swiper-wrapper').classList.remove('swiper-wrapper');
                    self.sliderThumbnailsElement.querySelectorAll('.js-swiper-slide').forEach(slide => slide.classList.remove('swiper-slide'));
                }

                return ;
            } else {
                /**
                 * Adds `swiper` classes.
                 */
                self.sliderElement.classList.add('swiper');
                self.sliderElement.querySelector('.js-swiper-wrapper').classList.add('swiper-wrapper');
                self.sliderElement.querySelectorAll('.js-swiper-slide').forEach(slide => slide.classList.add('swiper-slide'));

                if (self.sliderElementIsDesktop) {
                    self.sliderThumbnailsElement.classList.add('swiper');
                    self.sliderThumbnailsElement.querySelector('.js-swiper-wrapper').classList.add('swiper-wrapper');
                    self.sliderThumbnailsElement.querySelectorAll('.js-swiper-slide').forEach(slide => slide.classList.add('swiper-slide'));
                }

                return enableSwiper();
            }
        };

        const enableSwiper = function() {
            carousel = new Swiper(self.sliderElement, {
                slidesPerView: 1.1,
                spaceBetween: 10,
                threshold: 10,
                centeredSlides: true,
                centeredSlidesBounds: true,
                scrollbar: {
                    el: self.scrollbar,
                    draggable: true,
                    hide: false
                },
                breakpoints: {
                    768: {
                        slidesPerView: 1
                    }
                },
                on: {
                    init() {
                        if (self.sliderThumbnailsElement) {
                            // Manually setting height of container for Swiper vertical to work.
                            self.sliderThumbnailsElement.style.height = `${self.sliderElement.getBoundingClientRect().height}px`;

                            carouselThumbnails = new Swiper(self.sliderThumbnailsElement, {
                                direction: 'vertical',
                                modules: [ Mousewheel ],
                                mousewheel: true,
                                slidesPerView: 5.25,
                                spaceBetween: 10,
                                threshold: 10,
                                on: {
                                    init() {
                                        if (!window.hasVariants) {
                                            self.sliderThumbnailsElement.querySelectorAll('.js-pdp-media-gallery-thumbnail').forEach((button, index) => {
                                                button.addEventListener('click', () => {
                                                    carousel.slideTo(index);
                                                });
                                            })
                                        }
                                    }
                                }
                            });
                        }
                    },
                    resize() {
                        if (self.sliderThumbnailsElement) {
                            // Manually resetting height of container for Swiper vertical to work.
                            self.sliderThumbnailsElement.style.height = `${self.sliderElement.getBoundingClientRect().height}px`;
                        }
                    },
                    slideChange(swiper) {
                        if (self.sliderThumbnailsElement) {
                            carouselThumbnails.slideTo(swiper.activeIndex);
                            self.sliderThumbnailsElement.querySelectorAll('.swiper-slide').forEach(slide => slide.querySelector('.js-pdp-media-gallery-thumbnail').classList.remove('is-active'));
                            self.sliderThumbnailsElement.querySelectorAll('.swiper-slide')[swiper.activeIndex].querySelector('.js-pdp-media-gallery-thumbnail').classList.add('is-active');
                        }

                        if (self.sliderElementIsDesktop) {
                            if (swiper.activeIndex === 0) {
                                self.navigationPrev.disabled = true;
                            } else {
                                self.navigationPrev.disabled = false;
                            }

                            if (swiper.activeIndex + 1 === swiper.slides.length) {
                                self.navigationNext.disabled = true;
                            } else {
                                self.navigationNext.disabled = false;
                            }
                        }
                    }
                }
            });

            if (self.navigationPrev && self.navigationNext) {
                if (self.navigationPrev) {
                    self.navigationPrev.addEventListener('click', () => {
                        carousel.slidePrev();
                    });
                }

                if (self.navigationNext) {
                    self.navigationNext.addEventListener('click', () => {
                        carousel.slideNext();
                    });
                }
            }

            window.pdpCarousel = carousel;
            window.pdpCarouselThumbnails = carouselThumbnails;
        };

        if (breakpoint) {
            breakpoint.addEventListener('change', breakpointChecker);
            breakpointChecker();
        } else {
            enableSwiper();
        }
    }
}
